import {Activity} from "../models/activity.model";
import {getApiUrl} from "../utils/util-functions";

export const getActivityAsync = async (isPreviewMode: boolean = false) => {
    if (isPreviewMode) {
        return new Promise<any>((resolve) => {
            return [] as Activity[];
        });
    }

    return fetch(getApiUrl() + '/activity')
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'] as Activity[];
        });
};